import { useEffect } from "react";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { About } from "./components/About";
import { Expertise } from "./components/Expertise";
import { Career } from "./components/Career";
import { Work } from "./components/Work";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Cursor } from "./components/Cursor";
import { ScrollProgress } from "./components/ScrollProgress";
import { EmailCopyToast } from "./components/EmailCopyToast";
import { Tweaks } from "./components/Tweaks";

function App() {
  // Tab-title easter egg: nudge people who switch away to come back.
  useEffect(() => {
    const defaultTitle = document.title;
    const onVisibility = () => {
      document.title = document.hidden ? "👋 Come back! | Nehan" : defaultTitle;
    };
    document.addEventListener("visibilitychange", onVisibility);
    return () => document.removeEventListener("visibilitychange", onVisibility);
  }, []);

  return (
    <>
      <ScrollProgress />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Expertise />
        <Career />
        <Work />
        <Contact />
      </main>
      <Footer />

      <Cursor />
      <EmailCopyToast />
      <Tweaks />
    </>
  );
}

export default App;
